// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BillNavigation_rS38c {
  display: flex;
  flex-direction: column;
  gap: 20px;



  .state_j0ffx {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .stateStripeContainer_Exrcf {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .parametersContainer_tMC2C {
    transition: all 300ms;
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    overflow: hidden;
    interpolate-size: allow-keywords;
    display: flex;
    flex-direction: column;
    gap: 20px;

    ul {
      padding: 0;
      margin: 0;

      li {
        text-decoration: none;
        color: #333333;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 5px;
      }
    }
  }

  .infoBill_nTXxG {
    background-color: var(--white-color);
    padding: 10px 10px;
    border: 1px solid var(--ececf1-border);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
  }

  .payInfo_bJcYB {
    gap: 10px;
    color: var(--_75-color);

    padding: 10px 10px;
    width: 100%;
    height: min-content;

    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }

    .total_DuPRH {
      color: var(--_2-color);
      padding: 0 20px;
      font-weight: bold;
    }

    .totalToPay_Hgw_x {
      background-color: #2c2c2c;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding: 10px 20px;
      color: var(--white-background);
      font-weight: bold;
      font-size: 15px;

      p {
        padding: 0;
      }
    }
  }

  .searchIconsWrappers_Y3yUT {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 3px;
  }

  .parameters_ghGca {
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;

    svg {
      width: 13px;
      height: 13px;
    }
  }

  .background_auqte {
    background-color: transparent;
    color: #264f88;
    font-weight: bold;
    text-decoration: underline;
  }
}

.seeBillContainer_g9RS5 {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;

  embed {
    border-radius: 8px;
    overflow: visible !important;
    overflow-clip-margin: unset !important;
    scrollbar-width: none;
    -ms-overflow-style: none;

    embed::-webkit-scrollbar {
      display: none;
    }

  }


  .seeBillContainer_g9RS5::-webkit-scrollbar {
    display: none;
  }

  &:hover {
    .seeBillContent_IbDtP {
      display: flex;
    }
  }

  .seeBillContent_IbDtP {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 0;
    display: none;
    background-color: gray;
    color: var(--white-color);
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.approved_RKCkz {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #10A37F;
}

.btnContactInfoContainer_xx6r2 {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  justify-content: center;
  overflow-x: scroll;
  min-height: 44px;
  &::-webkit-scrollbar{
    display: none;
  }

  button {
    border-radius: 999px;

    svg {
      color: #0E1318;
      fill: #0E1318;
    }

    .activeBtn_LeUBS {
      color: var(--_10a37f-border);
      fill: var(--_10a37f-border);
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.tagsContainer_MHVJz {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .tag_Euyt0 {
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      width: 100%;
      padding: 10px 20px;
      border-radius: 10px;
    }
  }
}

.lessCategory_Xuauz {
  display: flex;
  align-items: center;
  gap: 5px;

  span {
    color: #10a37f;
  }
}

.lessCategoryContainer_PQO3E {
  display: flex;
  align-items: center;
  margin-left: -10px;
  padding: 15px 0px;
}

.textAndDragContainer_pUZHO {
  display: flex;
  align-items: center;
  padding: 5px 0px;
}

.textContainer_ElI9w {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 5px;

  .text_JiVKH {
    display: flex;
    flex-direction: column;

    .span1_uOrje {
      color: var(--black-color);
    }

    .span2_gxDU6 {
      color: #8E8E93;
      font-size: 13px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavigationPopups/BillNavigation/BillNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;;;EAIT;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,UAAU;MACV,SAAS;;MAET;QACE,qBAAqB;QACrB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,YAAY;MACd;IACF;EACF;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,uBAAuB;;IAEvB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;;IAEnB;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,8BAA8B;MAC9B,iBAAiB;MACjB,eAAe;;MAEf;QACE,UAAU;MACZ;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;;IAEf;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;IACjB,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,wBAAwB;;IAExB;MACE,aAAa;IACf;;EAEF;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;;IAEpB;MACE,cAAc;MACd,aAAa;IACf;;IAEA;MACE,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,WAAW;MACX,kBAAkB;MAClB,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;;EAEhB;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,yBAAyB;IAC3B;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;EACF;AACF","sourcesContent":[".BillNavigation {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n\n\n  .state {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .stateStripeContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .parametersContainer {\n    transition: all 300ms;\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -ms-transition: all 300ms;\n    -o-transition: all 300ms;\n    overflow: hidden;\n    interpolate-size: allow-keywords;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    ul {\n      padding: 0;\n      margin: 0;\n\n      li {\n        text-decoration: none;\n        color: #333333;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        padding: 5px;\n      }\n    }\n  }\n\n  .infoBill {\n    background-color: var(--white-color);\n    padding: 10px 10px;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .payInfo {\n    gap: 10px;\n    color: var(--_75-color);\n\n    padding: 10px 10px;\n    width: 100%;\n    height: min-content;\n\n    p {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 20px;\n    }\n\n    .total {\n      color: var(--_2-color);\n      padding: 0 20px;\n      font-weight: bold;\n    }\n\n    .totalToPay {\n      background-color: #2c2c2c;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 40px;\n      padding: 10px 20px;\n      color: var(--white-background);\n      font-weight: bold;\n      font-size: 15px;\n\n      p {\n        padding: 0;\n      }\n    }\n  }\n\n  .searchIconsWrappers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    user-select: none;\n    border-radius: 3px;\n  }\n\n  .parameters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    cursor: pointer;\n\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n  }\n\n  .background {\n    background-color: transparent;\n    color: #264f88;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n}\n\n.seeBillContainer {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  scroll-behavior: smooth;\n\n  embed {\n    border-radius: 8px;\n    overflow: visible !important;\n    overflow-clip-margin: unset !important;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    embed::-webkit-scrollbar {\n      display: none;\n    }\n\n  }\n\n\n  .seeBillContainer::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:hover {\n    .seeBillContent {\n      display: flex;\n    }\n  }\n\n  .seeBillContent {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: 10px 0;\n    display: none;\n    background-color: gray;\n    color: var(--white-color);\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n\n.approved {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #10A37F;\n}\n\n.btnContactInfoContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  justify-content: center;\n  overflow-x: scroll;\n  min-height: 44px;\n  &::-webkit-scrollbar{\n    display: none;\n  }\n\n  button {\n    border-radius: 999px;\n\n    svg {\n      color: #0E1318;\n      fill: #0E1318;\n    }\n\n    .activeBtn {\n      color: var(--_10a37f-border);\n      fill: var(--_10a37f-border);\n    }\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.tagsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .tag {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    span {\n      width: 100%;\n      padding: 10px 20px;\n      border-radius: 10px;\n    }\n  }\n}\n\n.lessCategory {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  span {\n    color: #10a37f;\n  }\n}\n\n.lessCategoryContainer {\n  display: flex;\n  align-items: center;\n  margin-left: -10px;\n  padding: 15px 0px;\n}\n\n.textAndDragContainer {\n  display: flex;\n  align-items: center;\n  padding: 5px 0px;\n}\n\n.textContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 5px;\n\n  .text {\n    display: flex;\n    flex-direction: column;\n\n    .span1 {\n      color: var(--black-color);\n    }\n\n    .span2 {\n      color: #8E8E93;\n      font-size: 13px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BillNavigation": `BillNavigation_rS38c`,
	"state": `state_j0ffx`,
	"stateStripeContainer": `stateStripeContainer_Exrcf`,
	"parametersContainer": `parametersContainer_tMC2C`,
	"infoBill": `infoBill_nTXxG`,
	"payInfo": `payInfo_bJcYB`,
	"total": `total_DuPRH`,
	"totalToPay": `totalToPay_Hgw_x`,
	"searchIconsWrappers": `searchIconsWrappers_Y3yUT`,
	"parameters": `parameters_ghGca`,
	"background": `background_auqte`,
	"seeBillContainer": `seeBillContainer_g9RS5`,
	"seeBillContent": `seeBillContent_IbDtP`,
	"approved": `approved_RKCkz`,
	"btnContactInfoContainer": `btnContactInfoContainer_xx6r2`,
	"activeBtn": `activeBtn_LeUBS`,
	"tagsContainer": `tagsContainer_MHVJz`,
	"tag": `tag_Euyt0`,
	"lessCategory": `lessCategory_Xuauz`,
	"lessCategoryContainer": `lessCategoryContainer_PQO3E`,
	"textAndDragContainer": `textAndDragContainer_pUZHO`,
	"textContainer": `textContainer_ElI9w`,
	"text": `text_JiVKH`,
	"span1": `span1_uOrje`,
	"span2": `span2_gxDU6`
};
export default ___CSS_LOADER_EXPORT___;
